import { SocialLoginMethod } from '@application/types';
import {
  Button,
  Card,
  InputWrapper,
  Modal,
  ModalCloseButton,
  ModalTitle,
  Section,
  SectionText,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { FaFacebookF } from 'react-icons/fa';
import type { FC } from 'react';
import type { UseSocialLoginModalProps } from './types';
import * as Styled from './styled';
import googleIcon from '../LoginForm/assets/google-icon.svg';

export * from './types';

export const UseSocialLoginModal: FC<UseSocialLoginModalProps> = (props) => {
  const {
    modal,
    loading,
    method = SocialLoginMethod.GOOGLE,
    onFacebookClick,
    onGoogleClick,
  } = props;

  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.modals.useSocialLogin',
  });

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <ModalTitle>{translateRessource('title')}</ModalTitle>
        <Section centerChildren>
          <SectionText>{translateRessource(`text.${method}`)}</SectionText>
        </Section>

        <Section centerChildren>
          {method === SocialLoginMethod.GOOGLE ? (
            <InputWrapper>
              <Button color="white" outlined onClick={onGoogleClick} disabled={loading}>
                <Styled.SsoButtonIconWrapper>
                  <img src={googleIcon} alt="" />
                </Styled.SsoButtonIconWrapper>
                {translate('common.buttons.googleLogin')}
              </Button>
            </InputWrapper>
          ) : (
            <InputWrapper>
              <Styled.SsoButtonFacebook color="blue" onClick={onFacebookClick} disabled={loading}>
                <Styled.SsoButtonIconWrapper>
                  <FaFacebookF />
                </Styled.SsoButtonIconWrapper>
                {translate('common.buttons.facebookLogin')}
              </Styled.SsoButtonFacebook>
            </InputWrapper>
          )}
        </Section>
      </Card>
    </Modal>
  );
};
